import { render } from "./draftUpload.vue?vue&type=template&id=127df7ca"
import script from "./draftUpload.vue?vue&type=script&lang=js"
export * from "./draftUpload.vue?vue&type=script&lang=js"

import "./draftUpload.vue?vue&type=style&index=0&id=127df7ca&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__